import styled, { css } from 'styled-components';
import { getInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { Deactivation, useTheme } from '../../common';
import { Playlist } from '../playlist';
import { Background } from './widget-types';

export function EmbedBackground() {
  const { font, playlistHeight } = useSettings();
  const { textColor } = useTheme();

  return (
    <Deactivation>
      <Container _font={font?.value || 'inherit'}>
        <Background />
        <StyledPlaylist
          maxHeight={playlistHeight}
          hideDirection="toTop"
          _textColor={textColor}
        />
      </Container>
    </Deactivation>
  );
}

const Container = styled.div<{
  _font: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: ${({ _font }) => _font};
`;

const StyledPlaylist = styled(Playlist)<{ _textColor: string }>`
  padding: 8px;

  ${({ _textColor }) => css`
    color: ${_textColor};
    background-color: ${getInvertedColor(_textColor)};
    width: 100%;
  `}
`;
